export default __webpack_public_path__ + "static/media/adas-map-logo.f06711e2.png";